import type { Theme } from "@mui/material/styles";
import { settingPageGrey } from "@octopus-settings/constants/ui/colors";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme: Theme) => ({
  appBar: {
    position: "relative",
    color: "transparent",
    backgroundColor: settingPageGrey[50],
    borderBottom: `1px solid ${settingPageGrey[200]}`,
    boxShadow: "none",
    filter: "none",
  },
  toolbar: {
    minHeight: 64,
    padding: theme.spacing(4, 6),
  },
}));

export default useStyles;
